// extracted by mini-css-extract-plugin
export default {"container":"container--n4XwJ","words-limit":"words-limit--rwJne","wordsLimit":"words-limit--rwJne","textarea":"textarea--xJNxi","error":"error--gsyyK"};